import { Link } from "react-router-dom";
import { SITE } from "@/lib/site";
import DisclaimerBanner from "@/components/DisclaimerBanner";

export default function About() {
  return (
    <div className="rr-reveal">
      {/* Header */}
      <section className="pt-24 md:pt-32 pb-16">
        <div className="max-w-5xl mx-auto px-6 sm:px-10 lg:px-12">
          <p
            className="text-xs tracking-[0.22em] uppercase mb-6 font-medium"
            style={{ color: "var(--rr-primary)" }}
          >
            About the instructor
          </p>
          <h1
            className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[1.04] tracking-tight"
            style={{ color: "var(--rr-text)" }}
            data-testid="about-title"
          >
            {SITE.instructor.name}
          </h1>
          <p className="mt-4 text-base" style={{ color: "var(--rr-text-2)" }}>
            {SITE.instructor.title}
          </p>
          <p className="mt-2 text-sm" style={{ color: "var(--rr-text-2)" }}>
            {SITE.instructor.credentials}
          </p>
        </div>
      </section>

      {/* Bio + credentials */}
      <section className="pb-24 md:pb-32">
        <div className="max-w-5xl mx-auto px-6 sm:px-10 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-7 space-y-6 text-base sm:text-lg leading-relaxed" style={{ color: "var(--rr-text-2)" }}>
            <p>
              Aimee Page has spent her career in the careful work of helping people understand their own nervous systems. She earned her master’s in trauma counseling from Thomas Jefferson University and is a licensed, board-certified psychotherapist.
            </p>
            <p>
              Rewire and Root is the course she wished her clients could take <em>before</em> sitting down in a therapy room — a calm, structured education in how the nervous system works, taught with the rigor of a clinician and the clarity of a teacher.
            </p>

            <div className="pt-8">
              <h3
                className="font-serif text-2xl sm:text-3xl tracking-tight"
                style={{ color: "var(--rr-text)" }}
              >
                The approach
              </h3>
              <p className="mt-4">
                Evidence-based. Clinically informed. Practical without being prescriptive. The course pairs the science of stress physiology and trauma-informed care with skills you can use in ordinary days — at work, in conversations, at the kitchen sink.
              </p>
              <p className="mt-4">
                What you won’t find: oversharing, performance vulnerability, or magical thinking. What you will find: a thoughtful framework, practical instruction and information, and a small, focused group.
              </p>
            </div>
          </div>

          <aside className="lg:col-span-5">
            <div
              className="border-t pt-8"
              style={{ borderColor: "var(--rr-border)" }}
            >
              <p
                className="text-xs tracking-[0.2em] uppercase mb-5"
                style={{ color: "var(--rr-primary)" }}
              >
                Credentials
              </p>
              <ul className="space-y-3 text-sm" style={{ color: "var(--rr-text-2)" }}>
                <li>Licensed Professional Counselor (LPC)</li>
                <li>National Certified Counselor (NCC)</li>
                <li>MS, Trauma Counseling — Thomas Jefferson University</li>
                <li>Licensed, board-certified psychotherapist</li>
              </ul>
            </div>
          </aside>
        </div>
      </section>

      <DisclaimerBanner testid="about-disclaimer-banner" />

      <section className="py-20 md:py-28" style={{ background: "var(--rr-surface)" }}>
        <div className="max-w-4xl mx-auto px-6 sm:px-10 lg:px-12">
          <h2
            className="font-serif text-4xl md:text-5xl leading-[1.05] tracking-tight"
            style={{ color: "var(--rr-text)" }}
          >
            The next cohort is open.
          </h2>
          <div className="mt-10">
            <Link
              to="/enroll"
              data-testid="about-enroll-cta"
              className="inline-flex items-center justify-center gap-3 px-8 py-4 text-sm font-medium"
              style={{ background: "var(--rr-primary)", color: "var(--rr-bg)" }}
            >
              Enroll for {SITE.priceLabel}
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
